import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { LoginService } from 'src/app/login/login.service';
import { BehaviorSubject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {

  private idleTimeout: any;
  private readonly idleTime = browserWindowEnv.idelTime * 60 * 1000;
  private twoMinuteRemaining;
  public showToastr : BehaviorSubject<boolean> = new BehaviorSubject(false);
  public twoMinTimer;
  private isWarningShown = false; // NEW: Track if warning was shown

  constructor(private ngZone: NgZone, private router: Router, private sharedService: SharedService, private loginService: LoginService,private modalService: NgbModal) { }

  resetTimer(): void {
    this.showToastr.next(false);

     // NEW: If warning was shown and user is now active, validate session with backend
    if (this.isWarningShown) {
      console.log('User became active after warning - validating session...');
      this.validateSession();
    }
    
    this.isWarningShown = false;
    this.twoMinuteRemaining = this.idleTime - ( 2 * 60 * 1000);
    clearTimeout(this.twoMinTimer);
    this.stopTimer();
    this.startTimer();
  }

  private startTimer(): void {

    this.twoMinTimer = setTimeout(() => {
      console.log("2 min")
      this.isWarningShown = true;
      this.showToastr.next(true);
    }, this.twoMinuteRemaining);
    
    this.idleTimeout = setTimeout(() => {
      // Perform logout or any other action here
      this.ngZone.run(() => {
        console.log('User is logged out due to inactivity.');
        this.showToastr.next(false);
        this.isWarningShown = false;
        this.logout();
      });
    }, this.idleTime); //this.idleTime);
  }

  private stopTimer(): void {
    clearTimeout(this.idleTimeout);
    clearTimeout(this.twoMinTimer);
  }
  // NEW METHOD: Validate session with backend
  private validateSession(): void {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No token found - logging out');
      this.logout();
      return;
    }

    // Call backend to validate token is still valid
    this.loginService.keepAlive().subscribe({
      next: (res: any) => {
        if (res.Message === 'OK' || res.IsValid) {
          console.log('Session validated successfully - user can continue');
          // Session is valid, user can continue
        } else {
          console.warn('Session validation returned unexpected response');
          this.logout();
        }
      },
      error: (err) => {
        console.error('Session validation failed:', err);
        // If 401, token is invalid/expired - logout
        if (err.status === 401) {
          console.error('Token expired or invalid - logging out');
          this.logout();
        }
      }
    });
  }
  logout() {
    this.modalService.dismissAll();
    this.sharedService.deleteCookie('token');
    this.sharedService.deleteCookie('OceanSystem');
    localStorage.clear();
    this.router.navigate(['login']);
    this.stopTimer();
    this.loginService.updateOnAuthChange(false);
  }
}
